import aiWriterWhite from './aiWriter-white.svg';
import aiWriter from './aiWriter.svg';
import loadingBlack from './loading-black.svg';
import loadingWhite from './loading-white.svg';
import loading from './loading.svg';
import radioSelectWhite from './radioSelect-white.svg';
import radioSelect from './radioSelect.svg';
import retryWhite from './retry-white.svg';
import retry from './retry.svg';
import uploadImageWhite from './uploadImage-white.svg';
import uploadImage from './uploadImage.png';
import uploadVoiceWhite from './uploadVoice.svg';
import uploadVoice from './voiceupload.svg';
import { isTalkie } from '../../utils';

export { default as arrowDown } from './arrowDown.png';
export const loadingIcon = isTalkie ? loadingWhite : loading;
export const loadingDarkIcon = isTalkie ? loadingBlack : loadingWhite;
export const aiWriterIcon = isTalkie ? aiWriterWhite : aiWriter;
export const radioSelectIcon = isTalkie ? radioSelectWhite : radioSelect;
export const retryIcon = isTalkie ? retryWhite : retry;
export const uploadImageIcon = isTalkie ? uploadImageWhite : uploadImage;
export const uploadVoiceIcon = isTalkie ? uploadVoiceWhite : uploadVoice;

export { default as uploadIcon } from './upload.svg';
export { default as robotIcon } from './robot.svg';
export { default as robotWhiteIcon } from './robotWhite.svg';
export { default as infoIcon } from './info.svg';
export { aiWriterWhite };
